// 📄 pages/Proyectos/components/IntegrationSection.tsx
// Tarjetas de acceso a la configuración de integración transversal a
// CUALQUIER solución activa del proyecto (Commerce, SLP, Sourcing, Buying,
// Contracts, ...) — no pertenecen a una solución puntual, así que viven
// acá y no en el sidebar de "Herramientas" (que es para catálogos/
// utilidades, no para configuración de canales). Se incluye al final del
// dashboard de cada solución (ver CommerceHome.tsx y
// SolucionPlaceholder.tsx) en vez de depender de un menú aparte.
//
// Sub-fase K9 (a pedido explícito del usuario, 2026-08-12): "Repositorio de
// Comunicación" (K5) vivía en el sidebar de Herramientas — se movió acá
// porque es configuración de canales de las soluciones (Acceso al Tenant +
// pool de Communication Users/Systems que referencian los Arrangements de
// K7), no una herramienta de catálogo/consulta como BAdIs o Credenciales.
import { Link } from 'react-router-dom';
import { Layers, Network } from 'lucide-react';
import { useProject } from '../../../context/ProjectContext.tsx';
import { esErpCloud } from '../../views/AribaCommerce/Integracion/useGeneralConfig.ts';

interface IntegrationSectionProps {
  projectId: string;
}

export default function IntegrationSection({ projectId }: IntegrationSectionProps) {
  const { project } = useProject();
  // Sub-fase K8: "ERP Add-on" no existe en Cloud (se reemplazó por Acceso
  // al Tenant, ver configuracionGeneral.tsx) — la descripción de esta
  // tarjeta ya no lo menciona ahí.
  const esCloud = esErpCloud(project?.erpTipo);

  return (
    <div>
      <h3 className="text-xl mb-4 font-medium text-green-200">Integración</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Link
          to={`/proyecto/${projectId}/integracion/generales`}
          className="block bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-5 transition-all duration-200"
        >
          <div className="text-blue-400 mb-2"><Layers /></div>
          <h4 className="text-lg font-semibold text-white">Configuraciones Generales</h4>
          <p className="text-sm text-gray-400 mt-1">
            {esCloud
              ? 'Configura los canales de integración del proyecto: Acceso al Tenant, Cloud Connector, Ariba Portal, CIG (Managed Gateway) y SR.'
              : 'Configura los canales de integración del proyecto: ERP Add-on, Cloud Connector, Ariba Portal, CIG (Managed Gateway) y SR.'}
          </p>
        </Link>

        {esCloud && (
          <Link
            to={`/proyecto/${projectId}/repositorio-comunicacion`}
            className="block bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-5 transition-all duration-200"
          >
            <div className="text-blue-400 mb-2"><Network /></div>
            <h4 className="text-lg font-semibold text-white">Repositorio de Comunicación</h4>
            <p className="text-sm text-gray-400 mt-1">
              Acceso al Tenant, Scopes habilitados y pool de Communication Users/Systems de S/4HANA Cloud.
            </p>
          </Link>
        )}
      </div>
    </div>
  );
}
